import styled from "styled-components";

export interface IFlex {
  inline?: boolean;
  flexDirection?: "row" | "column";
  justifyContent?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "space-between"
    | "space-around"
    | "initial"
    | "inherit";
  flexWrap?: "wrap" | "nowrap" | "wrap-reverse";
  alignItems?:
    | "stretch"
    | "center"
    | "flex-start"
    | "flex-end"
    | "baseline"
    | "initial"
    | "inherit";
  flexGrow?: number;
  flexShrink?: number;
  flexBasis?: number;
  flex?: string;
  padding?: string;
  margin?: string;
  width?: string;
  height?: string;
  maxWidth?: string;
  maxHeight?: string;
  gap?: string;
  border?: string;
}

const Flex = styled.div<IFlex>`
  display: ${({ inline }) => (inline ? "inline-flex" : "flex")};
  flex-direction: ${({ flexDirection }) => flexDirection || "row"};
  gap: ${({ gap }) => gap || "0"};
  justify-content: ${({ justifyContent }) => justifyContent || "initial"};
  flex-wrap: ${({ flexWrap }) => flexWrap || "nowrap"};
  align-items: ${({ alignItems }) => alignItems || "stretch"};
  flex-grow: ${({ flexGrow }) => flexGrow || "0"};
  flex-shrink: ${({ flexShrink }) => flexShrink || "1"};
  flex-basis: ${({ flexBasis }) => flexBasis || "auto"};
  flex: ${({ flex }) => flex || "initial"};
  padding: ${({ padding }) => padding || "0"};
  margin: ${({ margin }) => margin || "0"};
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "auto"};
  max-width: ${({ maxWidth }) => maxWidth || "none"};
  max-height: ${({ maxHeight }) => maxHeight || "none"};
  border: ${({ border }) => border || "none"};
`;

export { Flex };
